const Start = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-start"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-start"
      viewBox="0 0 16 15"
      width={_width}
      {...props}
    >
      <path
        d="M9.08125 2.19377L10.1813 4.39377C10.3313 4.70002 10.7313 4.99377 11.0688 5.05002L13.0625 5.38127C14.3375 5.59377 14.6375 6.51877 13.7188 7.43127L12.1688 8.98127C11.9063 9.24377 11.7625 9.75002 11.8438 10.1125L12.2875 12.0313C12.6375 13.55 11.8313 14.1375 10.4875 13.3438L8.61875 12.2375C8.28125 12.0375 7.725 12.0375 7.38125 12.2375L5.5125 13.3438C4.175 14.1375 3.3625 13.5438 3.7125 12.0313L4.15625 10.1125C4.2375 9.75002 4.09375 9.24377 3.83125 8.98127L2.28125 7.43127C1.36875 6.51877 1.6625 5.59377 2.9375 5.38127L4.93125 5.05002C5.2625 4.99377 5.6625 4.70002 5.8125 4.39377L6.9125 2.19377C7.5125 1.00002 8.4875 1.00002 9.08125 2.19377Z"
        // stroke="#7B7F82"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default Start;
